/**
 * The marker hues — the TS twin of the `--hue-*` tokens on `:root` in
 * app/index.html (Body-tab XD note 2026-09-27 §3.1, brief §1 "one token
 * file"). HUE MEANS WHICH OBJECT, never how far along it is (Allen, 2026-09-10:
 * "their color communicates a relationship… do not turn those dots into
 * generic urgency signals"); the FORM — ring, dashed, halo, ghost — carries
 * state (`shell/status-mark.ts`).
 *
 * The viewport's markers (three.js colours) read these numbers; the panel reads
 * the CSS tokens. `marker-hues.test.ts` pins the two to the same values, so a
 * hue changed in one place and not the other fails the suite.
 *
 * Depends on: nothing. Depended on by: hand-markers, elbow-placement-tool.
 */

/** One hue per digit, so the model's dot and the panel's swatch are visibly one object. */
export const DIGIT_HUE: Readonly<Record<'Thumb' | 'Index' | 'Middle' | 'Ring' | 'Pinky', number>> = {
  Thumb: 0xff9a3c,
  Index: 0xffd93d,
  Middle: 0x7dff8a,
  Ring: 0x5cc8ff,
  Pinky: 0xc08bff,
};
/** A pin nobody has named yet. */
export const UNNAMED_HUE = 0xd8d0e4;
/** The wrist mark (ADR-025) — the joint's own hue, distinct from every digit. */
export const WRIST_HUE = 0xe8f0ff;
/** The elbow's identity hue (ADR-036/037). */
export const ELBOW_HUE = 0x65e6ed;

/** The CSS token each hue is published as on `:root`. */
export const HUE_TOKENS: Readonly<Record<string, number>> = {
  '--hue-thumb': DIGIT_HUE.Thumb,
  '--hue-index': DIGIT_HUE.Index,
  '--hue-middle': DIGIT_HUE.Middle,
  '--hue-ring': DIGIT_HUE.Ring,
  '--hue-pinky': DIGIT_HUE.Pinky,
  '--hue-unnamed': UNNAMED_HUE,
  '--hue-wrist': WRIST_HUE,
  '--hue-elbow': ELBOW_HUE,
};
